module.exports = __webpack_public_path__ + "static/media/octopus.b68eaaa0.svg";